import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';


export const FlexSpacer = styled(Box)({
  display: 'flex',
  flex: '1',
});
